import { useGateValue } from '@coursera-web/statsig';

import { ENTERPRISE_LEARNER_CONTRACT_EXTENSION_GATE } from 'bundles/unified-home-common/constants/enterpriseLearnerContractExtensionGate';

/**
 * Statsig kill switch for learner contract extension UI (home banner + renewal bell).
 *
 * Must be called within a StatsigProvider.
 */
const useEnterpriseLearnerContractExtensionGate = (): boolean =>
  useGateValue(ENTERPRISE_LEARNER_CONTRACT_EXTENSION_GATE);

export default useEnterpriseLearnerContractExtensionGate;
